module.exports = __webpack_public_path__ + "static/media/seo.4cec730b.svg";